// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"Menu_itemContainer__17K9G","item":"Menu_item__37Vmk","icon":"Menu_icon__1VDcB","selected":"Menu_selected__uBhDT","disabled":"Menu_disabled__3dGoi"};